import classnames from "classnames";
import { Tooltip } from 'react-bootstrap';
import { FormattedMessage } from "react-intl";
import { DateTime } from 'luxon';
import DigiraatiRelativeTime from "../../../../../../common/DigiraatiRelativeTime";


const CommentAuthorAndDate = ({
  isOwnComment,
  isAuthorAdminUser,
  commentData,
}) => {

  /**
   * User DateTime to convert current timestamp to desired format.
   * @returns {String}
   */
  const parseTimestamp = (timestamp) => DateTime.fromISO(timestamp).toFormat('dd.MM.yyyy HH:mm');

  const dateTooltip =(
    <Tooltip id="comment-date-tooltip">
      {parseTimestamp(commentData.created_at)}
    </Tooltip>
  );

  return (
    <div className='hearing-comment-author-and-date'>
      <address
        className={classnames(
          'hearing-comment-author',
          {
          'hearing-comment-author-own': isOwnComment,
        })}
      >
        <span className="hearing-comment-author-username">{commentData.author_name || <FormattedMessage id="anonymous" />}</span>
        {isOwnComment && <span className="sr-only"><FormattedMessage id="ownComment" /></span> }
        <div className="hearing-comment-author-labels-container">
          {commentData.by_facilitator && <span className="hearing-comment-author-label"><FormattedMessage id="facilitator" /> </span>}
          {commentData.by_organizer && <span className="hearing-comment-author-label"><FormattedMessage id="organizer" /> </span>}
        </div>
      </address>
      {isAuthorAdminUser && (<address className="hearing-comment-author"><span className='hearing-comment-author-org-label'>{commentData.organization}</span></address>)}
        <time className="hearing-comment-date" title={parseTimestamp(commentData.created_at)} >
          <DigiraatiRelativeTime date={new Date(commentData.created_at)} />
        </time>
    </div>
  )
}

export default CommentAuthorAndDate;